import { defined } from "./defined.js";
export function createQueryString(...args) {
    const allArgs = args
        .filter(defined)
        .reduce((acc, curr) => {
        const currArgs = Object.entries(curr)
            .filter(([key, value]) => typeof value != "undefined")
            .map(([key, value]) => [key, `${value}`]);
        return acc.concat(currArgs);
    }, []);
    return new URLSearchParams(allArgs).toString();
}
//# sourceMappingURL=createQueryString.js.map